<template>
    <div class="system-picture-upload">
        <el-upload
            ref="upload"
            action=""
            class="upload-demo"
            :http-request="submitUpload"
            :show-file-list="false"
            :auto-upload="true"
            >
            <el-button size="mini" type="primary" icon="el-icon-upload2">
                {{$translate('lang.E3202102220002', { defaultText: '上传' })}}
            </el-button>
        </el-upload>
    </div>
</template>
<script>
import { uploadPictures } from '../../api/product';
const BYTES_PER_CHUNK = 5 * 1024 * 1024;
export default {
    data() {
        return {
            affixInf: {
                localFileName: null,
                downUrl: null
            }
        };
    },
    methods: {
        submitUpload(uploadData) {
            var FileExt = uploadData.file.name.replace(/.+\./, '');
            if (['docx', 'xlsx', 'xls', 'pptx', 'jpg', 'png', 'txt', 'zip', 'bmp', 'pdf', 'doc'].indexOf(FileExt.toLowerCase()) === -1) {
                this.$message.warning(this.$translate('lang.EXC202102260006', { defaultText: '文件上传类型不正确' }));
                this.$refs.upload.clearFiles();
            } else {
                if (uploadData.file.size > BYTES_PER_CHUNK) {
                    this.$message.warning(this.$translate('lang.EXC202103180001', { defaultText: '文件上传只支持5M以内' }));
                    this.$refs.upload.clearFiles();
                } else {
                    this.simpleUpload(uploadData);
                }
            }
        },
        // 视频上传测试
        simpleUpload(uploadData) {
            const form = new FormData();
            form.append('file', uploadData.file);
            uploadPictures(form).then(res => {
                if (res.code === '0') {
                    this.affixInf.localFileName = uploadData.file.name;
                    this.affixInf.downUrl = res.data.downUrl;
                    this.$emit('pushImg', this.affixInf);
                    this.$refs.upload.clearFiles();
                }
            }).catch(() => {
                this.$refs.upload.clearFiles();
            });
        }
    }
};
</script>
<style lang="less">
.system-picture-upload{
    .title{
        font-family: 'PingFangSC-Regular';
        font-size: 12px;
        color: rgba(0,0,0,0.25);
        line-height: 22px;
        text-align:center;
    }
}
</style>